import VueRouter from 'vue-router';
import Vue from 'vue';

import {

    ROUTE_PROSPECT_LOCATION,
    ROUTE_PROSPECT_FORM,
    ROUTE_ABOUT_US,
    ROUTE_MAP,
    ROUTE_PROVIDERS_LIST,
    ROUTE_PROVIDER_DASHBOARD,
    ROUTE_DASH_OVERVIEW,
    ROUTE_DASH_AREAS,
    ROUTE_CANCEL,
    ROUTE_DASH_CONFIG,
    ROUTE_USER_RECOVER,
    ROUTE_DASH_AREAS_EDIT,
    ROUTE_DASH_INTEGRATION,
    ROUTE_SPLASH,
    ROUTE_HOME_ACCOUNT,
    ROUTER_REGISTER_ACCOUNT

} from './routes';

const routes = [

    {
        path: ROUTE_SPLASH,
        component: () => import( /* webpackChunkName: "Splash" */ '../views/Prospect/Splash.vue'),
        name: 'Splash',
    },
    {
        path: ROUTE_USER_RECOVER + '/:token',
        component: () => import( /* webpackChunkName: "RecoverPassword" */ '../views/Provider/RecoverPassword'),
        name: 'RecoverPassword',
    },
    {
        path: ROUTE_HOME_ACCOUNT,
        component: () => import( /* webpackChunkName: "Login" */ '../views/Provider/Account/HomeAccount'),
        name: 'HomeAccount',

    },
    {
        path: ROUTER_REGISTER_ACCOUNT,
        component: () => import( /* webpackChunkName: "RegisterAccount" */ '../views/Provider/Account/RegisterAccount'),
        name: 'RegisterAccount',

    },
    {
        path: ROUTE_PROVIDER_DASHBOARD,
        component: () => import( /* webpackChunkName: "DashBoard" */ '../views/Provider/DashBoard'),
        name: 'DashBoard',
        children: [{
                path: ROUTE_DASH_OVERVIEW,
                component: () => import( /* webpackChunkName: "DashOverview" */ '../views/Provider/DashOverview.vue'),
                name: 'DashOverview'

            },
            {
                path: ROUTE_DASH_AREAS,
                component: () => import( /* webpackChunkName: "DashAreas" */ '../views/Provider/DashAreas.vue'),
                name: 'DashAreas'

            },
            {
                path: ROUTE_DASH_AREAS_EDIT,
                component: () => import( /* webpackChunkName: "DashMapArea" */ '../views/Provider/DashMapArea.vue'),
                name: 'DashMapArea'

            },
            {
                path: ROUTE_DASH_INTEGRATION,
                component: () => import( /* webpackChunkName: "DashIntegration" */ '../views/Provider/DashIntegration.vue'),
                name: 'DashIntegration'

            },
            {
                path: ROUTE_DASH_CONFIG,
                component: () => import( /* webpackChunkName: "DashConfig" */ '../views/Provider/DashConfig.vue'),
                name: 'DashConfig',
            },

        ]
    },
    {
        path: ROUTE_MAP,
        component: () => import( /* webpackChunkName: "viewsMap" */ '../views/Prospect/viewsMap.vue'),
        name: 'viewsMap',
        meta: {
            requires_guest: true,
        },
        children: [{
                path: ROUTE_PROSPECT_LOCATION,
                component: () => import( /* webpackChunkName: "Client" */ '../views/Prospect/Client.vue'),
                name: 'Client',
                meta: {
                    requires_guest: true,
                    // requires_prospect: true,
                },
            },
            {
                path: ROUTE_PROSPECT_FORM,
                component: () => import( /* webpackChunkName: "ClientForm" */ '../views/Prospect/ClientForm.vue'),
                name: 'ClientForm',
                meta: {
                    requires_guest: true,
                    requires_prospect: true,
                },
            },
            {
                path: ROUTE_PROVIDERS_LIST,
                component: () => import( /* webpackChunkName: "ProvidersList" */ '../views/Prospect/ProvidersList.vue'),
                name: 'ProvidersList',
                meta: {
                    requires_guest: true,
                    requires_prospect: true,
                },
            },

        ],
    },
    {
        path: ROUTE_ABOUT_US,
        name: 'About',
        component: () => import( /* webpackChunkName: "About" */ '../views/About/About.vue'),
        meta: {
            requires_guest: true,
        },
    },
    {
        path: ROUTE_CANCEL + '/:id',
        name: 'CancelEmail',
        component: () => import( /* webpackChunkName: "CancelEmail" */ '../views/Prospect/CancelEmail.vue'),

    },
    {
        path: '*',
        component: () => import( /* webpackChunkName: "Splash" */ '../views/Prospect/Splash.vue'),
        name: 'Splash',
        meta: {
            fallback: true,
        },
    },
];

const router = new VueRouter({
    mode: 'history',
    routes,
});

Vue.use(VueRouter);

export default router;